export default __webpack_public_path__ + "static/media/no-coupons.ad71d5a0.svg";